<template>
	<div class="border-top">
		<SOFilterTitle :title="'Kontak'" :diterapkan="diterapkan" :id="id"/>
		<div class="p-l-24 p-r-24 p-d-24" v-show="false" :id="id">
			<SOInputCheckbox :checkboxes="kontakKonsumen" @selected="selected" :checked="filterItem.kontakKonsumen"/>
		</div>
	</div>
</template>

<script>
import {mapGetters} from "vuex"

import SOFilterTitle from "@/so-components/global/filter/base/SOFilterTitle";
import SOInputCheckbox from "@/so-components/global/input/SOInputCheckbox";

export default {
	name: "SOFilterKontakKonsumen",
	components: {
		SOFilterTitle,
		SOInputCheckbox,
	},
	props: {
		id: String,
	},
	computed: {
		...mapGetters("filterGlobalModule", {
			filterItem: "getFilterItem"
		})
	},
	mounted() {
		this.diterapkan = this.filterItem.kontakKonsumen.length > 0
	},
	watch: {
		"filterItem.kontakKonsumen": {
			handler: function () {
				this.diterapkan = this.filterItem.kontakKonsumen.length > 0
			}
		}
	},
	data() {
		return {
			checked: [],
			kontakKonsumen: {
				name: "kontak-konsumen",
				data: [
					{
						id: "fkontak-1",
						value: "true",
						title: "Dengan nomor telpon",
						checked: false,
						titleBold: false,
					},
					{
						id: "fkontak-2",
						value: "false",
						title: "Tanpa nomor telpon",
						checked: false,
						titleBold: false,
					},
				]
			},
			diterapkan: false,
		}
	},
	methods: {
		selected(val) {
			let temp = this.filterItem
			temp.kontakKonsumen = val
			this.$store.commit("filterGlobalModule/setFilterItem", temp)
			this.diterapkan = this.filterItem.kontakKonsumen.length > 0
		}
	}
}
</script>